import { render, staticRenderFns } from "./SubdirectoryNew.vue?vue&type=template&id=77c46ec0&scoped=true"
import script from "./SubdirectoryNew.vue?vue&type=script&lang=js"
export * from "./SubdirectoryNew.vue?vue&type=script&lang=js"
import style0 from "./SubdirectoryNew.vue?vue&type=style&index=0&id=77c46ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c46ec0",
  null
  
)

export default component.exports